<mat-card appearance="raised">
  <mat-card-header class="card-header">
    <mat-card-title>Liquidity event</mat-card-title>
    <button [disabled]="data.resolutionDate"
            mat-icon-button
            (click)="addLiquidityEventDialog()"
            aria-label="Add">
      <mat-icon>add_circle</mat-icon>
    </button>
  </mat-card-header>

  <mat-card-content class="mat-card-content layout padding-bottom-md" *ngIf="data.resolutionDate">
    <div class="list-container">
      <mat-list>
          <mat-list-item>
              <h4 matListItemTitle>Resolution</h4>
              <p matListItemLine>{{resolutionStatusName}}, {{data?.resolutionDate | date : 'shortDate' }}</p>
            </mat-list-item>
      </mat-list>
      <button mat-icon-button aria-label="Add" (click)="delete()">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </mat-card-content>
</mat-card>
